export default __webpack_public_path__ + "static/media/1.4be7232a.jpg";